// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_NO_RESULTS = "Zat\u00edm nem\u00e1\u0161 ulo\u017een\u00e9 \u017e\u00e1dn\u00e9 ko\u010d\u00e1rky.";
